import { Component, OnInit, ViewChild } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";

import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import Player from "@vimeo/player";

import * as CryptoJS from "crypto-js";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-video-provider",
  templateUrl: "./video-provider.component.html",
  styleUrls: ["./video-provider.component.css"],
})
export class VideoProviderComponent implements OnInit {
  @ViewChild("vimeoVideoContainer") vimeoVideoContainer;

  public player: Player;
  constructor(
    private service: BaseService,

    private route: ActivatedRoute,
    private router: Router,

    public translate: TranslateService
  ) {}
  public_id: any;
  reletedShows: any = [];
  videoDetail: any;
  thumbnails: any;
  loading_player = false;
  app_constant: any;
  background;
  any;
  isPlaying = false;
  navigationSubscription: any;
  shimmerStatus = {
    relatedvideo: true,
    poster: true,
  };
  videoId: string;
  providerType: string;
  isLogin: boolean;
  encodeUrl: any;
  commentData = [];
  showComment = false;
  sendData: any = { offset: 0, limit: 2 };
  commentCount: any;

  ngOnInit(): void {
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(this.router.url),
      environment.secretkey
    ).toString();
    if (localStorage.getItem(environment.localStorageKey)) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    this.app_constant = environment;
    this.navigationSubscription = this.route.params.subscribe((params) => {
      this.loading_player = false;
      this.public_id = params["public_id"];
      this.providerType = params["slug"];
      this.isPlaying = false;
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      window.scrollTo(0, 0);
      // this.getComment();
      this.shimmerStatus.poster = true;
      this.service.videoDetailService(this.public_id).subscribe(
        (detail) => {
          this.shimmerStatus.poster = false;
          this.loading_player = true;
          this.videoDetail = detail.results;
          this.checkVideoStatus();
          if (
            this.providerType === "youtube" ||
            this.providerType === "daily_motion"
          ) {
            const url = new URL(this.videoDetail.output_url);
            this.videoId = url.searchParams.get("v");
          } else if (this.providerType === "vimeo") {
            const outputUrl = new URL(this.videoDetail.output_url);
            this.videoId = outputUrl.searchParams.get("v");
            setTimeout(() => {
              this.player = new Player(this.vimeoVideoContainer.nativeElement, {
                id: this.videoId, // Generic Id
                responsive: true,
              });
              this.player.on("play", () => {
                this.isPlaying = true;
              });
              this.player.on("pause", () => {
                this.isPlaying = false;
              });
              this.player.on("ended", () => {
                this.changeVideo(this.reletedShows[0]);
              });
            }, 500);
          }

          const index = detail.results.thumbnails
            .map((el) => {
              return el.image_type;
            })
            .indexOf("banner");
          if (index !== -1) {
            this.thumbnails = detail.results.thumbnails[index].asset;
          }
          if (detail) {
            this.service
              .relatedShowsService(this.public_id)
              .subscribe((res) => {
                this.shimmerStatus.relatedvideo = false;
                if (res) {
                  this.reletedShows = res.results;
                }
              });
          }
        },
        (err) => {
          if (err) {
            this.shimmerStatus.poster = false;
            this.shimmerStatus.relatedvideo = false;
            this.loading_player = false;
          }
        }
      );
    });
  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  customOptionsvideo: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      "",
      "",
      //'<span class="icon-arrow-left"></span>',
      //'<span class="icon-arrow-left"></span>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      370: {
        items: 2,
      },
      650: {
        items: 3,
      },
      925: {
        items: 4,
      },
      1108: {
        items: 4,
      },
      1257: {
        items: 5,
      },
      1460: {
        items: 6,
      },
    },
    nav: true,
  };

  playVideo() {
    this.loading_player = true;
  }
  videoStatus(event) {
    if (event.videoStatus == "ended") {
      this.changeVideo(this.reletedShows[0]);
    }
    this.isPlaying = event.isPlaying;
  }

  changeVideo(data: any) {
    if (data.source === "system" && data.type === "video") {
      this.router.navigate(["/video-detail", data.public_id]);
    } else if (data.source === "system" && data.type === "series") {
      this.router.navigate(["/series", data.public_id]);
    } else {
      this.router.navigate(["/provider", data.source, data.public_id]);
    }
  }

  savePlayer(player) {
    this.player = player;
  }
  onStateChange(event) {
    if (event.data === 1) {
      this.isPlaying = true;
    } else if (event.data === 2) {
      this.isPlaying = false;
    } else if (event.data === 0) {
      this.changeVideo(this.reletedShows[0]);
    }
  }
  playDailyMotion() {
    this.isPlaying = true;
  }
  pauseDailyMotion() {
    this.isPlaying = false;
  }

  checkVideoStatus() {
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.videoDetail.is_login_required === "yes") {
      if (encryptedData) {
        if (this.videoDetail.is_access === "free") {
          this.videoDetail.videoStatus = true;
        } else {
          if (this.videoDetail.is_user_content_purchase === "yes") {
            this.videoDetail.videoStatus = true;
          } else {
            this.videoDetail.bannerStatus = true;
          }
        }
      } else {
        this.router.navigate(["/login"], {
          queryParams: { public_id: this.encodeUrl },
        });
      }
    } else {
      this.videoDetail.videoStatus = true;
    }
  }

  getComment() {
    this.sendData.public_id = this.public_id;
    this.service.getComment(this.sendData).subscribe((res) => {
      this.commentData = this.commentData.concat(res.results);
      this.commentCount = res.counts;
    });
  }

  commentToggle() {
    this.sendData.offset = 0;
    if (this.showComment) {
      this.showComment = false;
    } else {
      this.getComment();
      this.showComment = true;
    }
  }
}
